module.exports = __webpack_public_path__ + "img/9-filters-01.519f3675.svg";